// extracted by mini-css-extract-plugin
module.exports = {"root":"Radio_root__3BQsd","label":"Radio_label__3CM4m","checkMark":"Radio_checkMark__1oaa0","disabled":"Radio_disabled__1ho9S"};